import script from "./ExperienceDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceDetailPage.vue?vue&type=style&index=0&id=4877d486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4877d486"]])

export default __exports__